import React, { useContext, useState } from "react";

import AgGrid from "../../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";
import AgregarDevolucionInterna from "../DevolucionesInternasCRUD/AgregarDevolicionInterna";
import Loader from "../../../../../../Base/Components/Loader/Loader";
import { Checkbox } from "primereact/checkbox";

const DevolucionesInternasListado = ({
  listadoDev,
  getInfo,
  selectedDetalle, 
  setSelectedDetalle,
  setShowDialogRM,
  setShowRequisa,
  loading
}) => {

  const { userAuth } = useContext(AuthContext);
  const [showDialogD, setShowDialogD] = useState(false);
  const [hiddenPriceColumn, setHiddenPriceColumn] = useState(
    userAuth.AccessWeb.split(",")
      .map((e) => parseInt(e))
      .includes(29)
  );


  const Requisa = (Id) => {
    setShowRequisa(Id);
    showModal();
  };

  const showModal = () => {
    setShowDialogRM(true);
  };



  const columns = [
    {
      field: "IdDevolucionDetalle",
      header: "ID",
      headerEn: "ID",
      body: (rowData) => rowData.IdDevolucionDetalle,
      frozen: "frozen",
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      field: "FechaDevolucion",
      header: "Fecha Devolucion",
      headerEn: "Date Returns",
      body: (rowData) => rowData.FechaDevolucion,
      frozen: "frozen",
      className: "medium",
      Format:'DateTime2'
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "StatusName",
      frozen: true,
      className: "medium",
      Format: "Estado",
      body: (rowData) => ({ ID: rowData.IdEstado, Estado: rowData.StatusName }),
    },
    {
      field: "Requisa",
      header: "Requisa de Material",
      headerEn: "Material Requisition",
      className: "small",
      Format: "Modal",
      frozen: true,
      align: "center",
      onCellDoubleClicked: ({ data }) => {
        Requisa(data.Requisa);
      },
      Sumary: 'count',
    },
    {
      field: "CodigoProducto",
      header: "Codigo",
      headerEn: "Product",
      className: "Xsmall",
      body: (rowData) => rowData.CodigoProducto,
    },
    {
      field: "NombreProducto",
      header: "Nombre Producto",
      headerEn: "Product Name",
      className: "large",
      body: (rowData) => rowData.NombreProducto,
    },
    {
      field: "DescripcionProducto",
      header: "Descripción",
      headerEn: "Description",
      className: "large",
    },
    {
      field: "NombreCategoria",
      header: "Tipo Producto",
      headerEn: "Product Type",
      className: "small",
      body: (rowData) => rowData.NombreTipoProducto,
    },
    {
      field: "NombreSubcategoria",
      header: "Categoría",
      headerEn: "Category",
      className: "small",
    },
    {
      field: "NombreTipoProducto",
      header: "SubCategoría",
      headerEn: "Sub Category",
      className: "medium",
    },
    {
      field: "QtySalida",
      header: "Despachado",
      headerEn: "Shipped",
      Sumary: "sum",
      className: "small",
      Format: "Currency",
    },
    // LEMPIRAS
    {
      headerName: "Lempiras",
      children: [
        {
          header: "Precio L",
          headerEn: "Price L",
          field: "PrecioL",
          hidden: hiddenPriceColumn,
          Format: "Currency",
          className: "Xsmall",
        },
        {
          header: "Monto L",
          headerEn: "Amount L",
          field: "MontoL",
          hidden: hiddenPriceColumn,
          Sumary: "sum",
          Format: "Currency",
          className: "Xsmall",
        },
      ],
    },
    // DOLARES
    {
      headerName: "Dolares",
      children: [
        {
          header: "Precio D",
          headerEn: "Price D",
          field: "PrecioD",
          hidden: hiddenPriceColumn,
          Format: "Currency",
          className: "Xsmall",
        },
        {
          header: "Monto D",
          headerEn: "Amount D",
          field: "MontoD",
          hidden: hiddenPriceColumn,
          Sumary: "sum",
          Format: "Currency",
          className: "Xsmall",
        },
      ],
    },
    {
      field: "Revisado",
      header: "Revisado",
      className: "Xsmall",
      Format: "Template",
      frozen: "true",
      alignFrozen: "right",
      filter: false,
      body: (rowData) => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <Checkbox checked={rowData.Revisado === 1 ? true : false}/>
        </div>
      ),
    },
    {
      // Comment
      field: "CantidadDevolucion",
      header: "Cantidad Devuelta",
      headerEn: "Refund Amount",
      Sumary: "sum",
      className: "small",
      Format: "Currency",
      frozen: "true",
      alignFrozen: "right",
    },
  ];

  const table = {
    Columns: columns,
    Data: listadoDev,
    selected: selectedDetalle,
    setSelected: (e) => setSelectedDetalle(e),
    showModal: (e) => showModal(e),
  };


  return (
    <div style={{ height: "88vh" }}>
      <Loader loading={loading}></Loader>
      <AgGrid table={table} />

      {showDialogD && (
        <AgregarDevolucionInterna
          selected={selectedDetalle}
          setSelected={setSelectedDetalle}
          showDialogDI={showDialogD}
          setShowDialogDI={setShowDialogD}
          getInfo={getInfo}
          actualizarScreen={getInfo}
        />
      )}
    </div>
  );
};

export default DevolucionesInternasListado;
